import React, { useEffect, useState } from 'react';
import styles from './shop.module.css'; 
import '@fortawesome/fontawesome-free/css/all.min.css';

function Shop() {
  // Slider state
  const [activeSlide, setActiveSlide] = useState(0);
  const slideCount = 4;

  // Product Config state
  const [selectedModel, setSelectedModel] = useState('pro');
  const [selectedColor, setSelectedColor] = useState('natural');
  const [selectedStorage, setSelectedStorage] = useState('256');

  const colorNames = {
    natural: 'Titan Tự Nhiên',
    blue: 'Titan Xanh',
    white: 'Titan Trắng',
    black: 'Titan Đen'
  };

  // Mỗi màu có 4 hình riêng cho slider
  const colorSliderImages = {
    natural: [
      `${process.env.PUBLIC_URL}/images/natural-1.jpeg`,
      `${process.env.PUBLIC_URL}/images/natural-2.jpeg`,
      `${process.env.PUBLIC_URL}/images/natural-3.jpeg`,
      `${process.env.PUBLIC_URL}/images/natural-4.jpeg`
    ],
    blue: [
      `${process.env.PUBLIC_URL}/images/blue-1.jpeg`,
      `${process.env.PUBLIC_URL}/images/blue-2.jpeg`,
      `${process.env.PUBLIC_URL}/images/blue-3.jpeg`,
      `${process.env.PUBLIC_URL}/images/blue-4.jpeg`
    ],
    white: [
      `${process.env.PUBLIC_URL}/images/white-1.jpg`,
      `${process.env.PUBLIC_URL}/images/white-2.jpg`,
      `${process.env.PUBLIC_URL}/images/white-3.jpg`,
      `${process.env.PUBLIC_URL}/images/white-4.jpg`
    ],
    black: [
      `${process.env.PUBLIC_URL}/images/black-1.jpg`,
      `${process.env.PUBLIC_URL}/images/black-2.jpg`,
      `${process.env.PUBLIC_URL}/images/black-3.jpg`,
      `${process.env.PUBLIC_URL}/images/black-4.jpg`
    ]
  };
  
  const summaryImages = {
    natural: `${process.env.PUBLIC_URL}/images/summary-natural.png`,
    blue: '/images/summary-blue.jpg',
    white: '/images/summary-white.jpg',
    black: '/images/summary-black.jpg'
  };

  const prices = {
    pro: {
      256: { total: '28.999.000₫', monthly: '1.181.000₫', deposit: '5.799.800₫', tax: '2.636.273₫' },
      512: { total: '34.999.000₫', monthly: '1.425.000₫', deposit: '6.999.800₫', tax: '3.181.727₫' },
      1024: { total: '40.999.000₫', monthly: '1.669.000₫', deposit: '8.199.800₫', tax: '3.727.182₫' }
    },
    promax: {
      256: { total: '34.999.000₫', monthly: '1.425.000₫', deposit: '6.999.800₫', tax: '3.181.727₫' },
      512: { total: '40.999.000₫', monthly: '1.669.000₫', deposit: '8.199.800₫', tax: '3.727.182₫' },
      1024: { total: '46.999.000₫', monthly: '1.914.000₫', deposit: '9.399.800₫', tax: '4.272.636₫' }
    }
  };

  // ✅ SET BODY STYLE khi vào Shop page
  useEffect(() => {
    // Lưu style cũ
    const originalBg = document.body.style.backgroundColor;
    const originalColor = document.body.style.color;
    const originalFont = document.body.style.fontFamily;
    const originalLine = document.body.style.lineHeight;
    
    // Set style cho Shop
    document.body.style.backgroundColor = '#fbfbfd';
    document.body.style.color = '#1d1d1f';
    document.body.style.fontFamily = "'SF Pro Display', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
    document.body.style.lineHeight = '1.6';
    document.body.style.overflowX = 'hidden';
    
    // Cleanup: khôi phục khi unmount
    return () => {
      document.body.style.backgroundColor = originalBg;
      document.body.style.color = originalColor;
      document.body.style.fontFamily = originalFont;
      document.body.style.lineHeight = originalLine;
      document.body.style.overflowX = '';
    };
  }, []);

  // ✅ Reset slider về slide 0 khi đổi màu
  useEffect(() => {
    setActiveSlide(0);
  }, [selectedColor]);

  // Intersection Observer for animations
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    const elements = document.querySelectorAll(
      `.${styles.heroTitle}, .${styles.mainContainer}, .${styles.footerSummary}`
    );
    elements.forEach((el) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(20px)';
      el.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  // Slider functions
  const nextSlide = () => setActiveSlide((prev) => (prev + 1) % slideCount);
  const prevSlide = () => setActiveSlide((prev) => (prev - 1 + slideCount) % slideCount);
  const goToSlide = (index) => setActiveSlide(index);

  // Config functions
  const selectModel = (model) => setSelectedModel(model);
  const selectColor = (color) => setSelectedColor(color);
  const selectStorage = (storage) => setSelectedStorage(storage);

  const priceData = prices[selectedModel][selectedStorage];
  const currentColorImages = colorSliderImages[selectedColor];

  return (
    <main className={styles.content}>
      {/* Hero Title */}
      <div className={styles.heroTitle}>
        <h1>Mua iPhone 15 Pro</h1>
      </div>

      {/* Main Container */}
      <div className={styles.mainContainer}>
        {/* Slider Section */}
        <div className={styles.sliderSection}>
          <div className={styles.slider}>
            <div
              className={styles.list}
              style={{ 
                transform: `translateX(-${100 * activeSlide}%)`, 
                transition: 'transform 0.6s ease-out' 
              }}
            >
              {currentColorImages.map((img, i) => (
                <div className={styles.item} key={i}>
                  <img src={img} alt={`iPhone 15 Pro ${colorNames[selectedColor]} - Góc ${i + 1}`} loading="lazy" />
                </div>
              ))}
            </div>
            <div className={styles.buttons}>
              <button id="prev" onClick={prevSlide} aria-label="Previous">
                <i className="fas fa-chevron-left"></i>
              </button>
              <button id="next" onClick={nextSlide} aria-label="Next">
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
            <ul className={styles.dots}>
              {[0, 1, 2, 3].map((i) => (
                <li
                  key={i}
                  className={i === activeSlide ? styles.active : ''}
                  onClick={() => goToSlide(i)}
                ></li>
              ))}
            </ul>
          </div>
        </div>

        {/* Config Sidebar */}
        <aside className={styles.configSidebar}>
          <div className={styles.promoBadge}>Nhận 800.000₫—22.000.000₫ khi đổi.**</div>

          <h2 className={styles.sectionTitle}>
            Phiên bản. <span className={styles.subtitle}>Mẫu nào phù hợp nhất với bạn?</span>
          </h2>

          <div
            className={`${styles.optionCard} ${selectedModel === 'pro' ? styles.selected : ''}`}
            onClick={() => selectModel('pro')}
          >
            <div className={styles.optionInfo}>
              <h3>iPhone 15 Pro</h3>
              <p>Màn hình 6.1 inch¹</p>
            </div>
            <div className={styles.optionPrice}>
              <p>Từ {prices.pro[selectedStorage].total}<br />hoặc {prices.pro[selectedStorage].monthly}/tháng<br />trong 24 tháng*</p>
            </div>
          </div>

          <div
            className={`${styles.optionCard} ${selectedModel === 'promax' ? styles.selected : ''}`}
            onClick={() => selectModel('promax')}
          >
            <div className={styles.optionInfo}>
              <h3>iPhone 15 Pro Max</h3>
              <p>Màn hình 6.7 inch¹</p>
            </div>
            <div className={styles.optionPrice}>
              <p>Từ {prices.promax[selectedStorage].total}<br />hoặc {prices.promax[selectedStorage].monthly}/tháng<br />trong 24 tháng*</p>
            </div>
          </div>

          <a href="/" className={styles.helpLink}>
            <strong>Bạn cần trợ giúp chọn một phiên bản?</strong>
            <p>Khám phá sự khác biệt về kích thước màn hình và thời lượng pin.</p>
          </a>

          <h2 className={styles.sectionTitle}>
            Màu. <span className={styles.subtitle}>Chọn màu bạn yêu thích.</span>
          </h2>

          <div className={styles.colorSelector}>
            <div className={styles.colorName}>Màu - {colorNames[selectedColor]}</div>
            <div className={styles.colorButtons}>
              {['natural', 'blue', 'white', 'black'].map((color) => (
                <button
                  key={color}
                  className={`${styles.colorBtn} ${styles[color]} ${selectedColor === color ? styles.selected : ''}`}
                  onClick={() => selectColor(color)}
                  aria-label={colorNames[color]}
                ></button>
              ))}
            </div>
          </div>

          <h2 className={styles.sectionTitle}>
            Dung lượng lưu trữ. <span className={styles.subtitle}>Bạn cần bao nhiêu dung lượng?</span>
          </h2>

          {['256', '512', '1024'].map((storage) => (
            <div
              key={storage}
              className={`${styles.optionCard} ${selectedStorage === storage ? styles.selected : ''}`}
              onClick={() => selectStorage(storage)}
            >
              <div className={styles.optionInfo}>
                <h3>{storage}GB²</h3>
              </div>
              <div className={styles.optionPrice}>
                <p>Từ {prices[selectedModel][storage].total}<br />hoặc {prices[selectedModel][storage].monthly}/tháng<br />trong 24 tháng*</p>
              </div>
            </div>
          ))}

          <a href="/" className={styles.helpLink}>
            <strong>Bạn không chắc mình cần bao nhiêu dung lượng?</strong>
            <p>Hiểu rõ hơn về dung lượng bạn cần.</p>
          </a>
        </aside>
      </div>

      {/* Footer Summary */}
      <div className={styles.footerSummary}>
        <div className={styles.m1}>
          <h2>
            {selectedModel === 'pro' ? 'iPhone 15 Pro' : 'iPhone 15 Pro Max'} mới của<br />bạn.<br />Theo cách bạn muốn.
          </h2>
          <img 
            src={summaryImages[selectedColor]} 
            alt={`${selectedModel === 'pro' ? 'iPhone 15 Pro' : 'iPhone 15 Pro Max'} ${colorNames[selectedColor]}`} 
          />
        </div>

        <div className={styles.m2}>
          <h4>
            {selectedModel === 'pro' ? 'iPhone 15 Pro' : 'iPhone 15 Pro Max'} {selectedStorage}GB {colorNames[selectedColor]}
          </h4>
          <h4>
            Tổng cộng {priceData.total}<br />
            hoặc<br />
            {priceData.monthly}/tháng mỗi tháng cho 24 tháng*<br />
            <samp>ở mức phí dịch vụ 1.67%, sau khi thanh toán lần đầu 20% là {priceData.deposit}</samp>
          </h4>
          <p>Bao gồm thuế GTGT khoảng {priceData.tax}.*</p>
          <a href="/">Khám phá thêm các lựa chọn trả góp hàng tháng</a>
          <hr className={styles.hr} />
          <h4>
            Vẫn chưa thể quyết định?<br />
            <samp>Bạn có thể nhấn "Lưu để xem lại sau" để dễ dàng quay lại xem sản phẩm.</samp>
          </h4>
          <a href="/">Lưu để xem lại sau</a>
          <hr className={styles.hr} />
          <p>Chi tiết giao hàng cho khu vực của bạn sẽ được hiển thị trong phần Thanh Toán.</p>
        </div>

        <div className={styles.m3}>
          <h4>Giao hàng:</h4>
          <p>
            <strong>Còn hàng</strong><br />
            Vận Chuyển Miễn Phí
          </p>
          <a href="/">Nhận thông tin về ngày giao hàng</a>
          <button className={styles.buttonAlternative}>
            Thêm vào giỏ hàng
          </button>
        </div>
      </div>
    </main>
  );
}

export default Shop;